export default __webpack_public_path__ + "static/taichinh-30c0bc7c3d4653c35e91594cb91cf456.jpg";